export default class BaseCharacter extends Phaser.GameObjects.Image {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser
   *
   *
   */

  constructor(scene, id, character, skin, animations, sfx) {
    super(scene, 0, 0, 'blank');
    // this.load.spine(character, json, atlas);
    this.spineRef = character;
    this.name = skin;
    this.animations = animations;
    this.idleAnims = animations.idles;
    this.charActive = true;
    this.shuffle(this.idleAnims);
    this.sfx = sfx;
    this.emitter = new Phaser.Events.EventEmitter();
    scene.add.existing(this);
    this.ID = id;
    this.minIdleTime = 1000;
    this.maxIdleTime = 3000;
    this.idleCounter = this.randomRange(0, this.maxIdleTime);
    this.idleTime = Phaser.Math.Between(this.minIdleTime, this.maxIdleTime);
    this.prevTimescale = 1;
    // console.log('creating character --> ' + skin + ' from ' + character);
    this.spineChar = scene.add.spine(0, 0, character, this.lastPlayedAnim, true);
    // this.spineChar.on('spine.complete', this.handleAnimComplete, this);
    this.clickArea = scene.add.image(0, 0, 'blank');
    this.clickArea.setOrigin(0.5, 1);
    this.setSkin(skin);
    this.lastPlayedAnim = animations.default;
    this.transform = scene.add.container(0, 0);
    let container = scene.add.container(0, 0, [this.spineChar, this.clickArea]);
    // this.setOrigin(0.5, 1);
    this.transform.add(container);
    this.frozen = false;
    this.canIdle = true;
    this.idleActive = true;
    this.charActive = true;
  }

  kill() {
    this.clickArea.off('pointerdown');
  }

  wrap(value) {
    return value % 360;
  }

  setTransform(posX, posY, scaleX, scaleY, dir) {
    var x = posX;
    var y = posY;

    this.transform.setPosition(x, y);

    // this.transform.setRandomPosition();
    this.direction = dir;
    this.spineChar.setScale(scaleX * this.direction, scaleY);
    this.texBounds = this.spineChar.getBounds();
    this.charWidth = this.texBounds.size.x * this.spineChar.scaleX;
    this.charHeight = this.texBounds.size.y * this.spineChar.scaleY;
    this.clickArea.setDisplaySize(this.charWidth, this.charHeight);
  }

  updateCharacter(time, delta, scene) {
    if (this.idleActive == true && this.frozen == false) {
      this.updateIdle(scene, delta);
    }
  }

  shuffle(arr) {
    arr.sort(() => Math.random - 0.5);
  }

  updateIdle(scene, delta) {
    if (this.idleCounter >= this.idleTime) {
      // do idle anim
      this.resetIdle();
      this.setTimescale(0.9, 1.1);
      this.playAnimVariant(scene, this.idleAnims, 'IDLE');

    } else {
      this.idleCounter += delta;
    }
  }

  setSortOrder(depth) {
    this.spineChar.depth = depth;
  }

  randomRange(min, max, round = false) {
    if (round) {
      return Phaser.Math.Between(min, max);
    } else {
      return Phaser.Math.Between(min * 100, max * 100) / 100;
    }
  }

  setSkin(skinName) {
    this.spineChar.setSkin(null);
    this.spineChar.setSkinByName(skinName);
    this.attachments = this.spineChar.skeleton.skin.attachments;
  }

  setTimescale(min, max) {
    let low = min * 100;
    let high = max * 100;
    let tScale = Phaser.Math.Between(low, high) / 100;
    this.spineChar.state.timeScale = tScale;
  }

  playAnim(scene, anim, mix, loop = false, returnToPrevious = true) {
    if (mix > 0) {
      this.spineChar.setMix(this.currentAnim, anim, mix);
      this.spineChar.setAnimation(0, anim, loop, 0);
      if (loop == false) {
        let track = this.spineChar.state.getCurrent(0);
        if (track !== undefined) {
          let delay = track.getAnimationLength();
          this.spineChar.setMix(anim, this.animations.default, mix);
          this.spineChar.addAnimation(0, this.animations.default, true, delay - mix);
        }

      }
    }

    this.playing = true;
    this.returnToPrevious = returnToPrevious;
    this.currentAnimation = anim;
  }

  playAnimVariant(scene, animations, /* debugTrace */) {

    let idx = Phaser.Math.Between(0, animations.length - 1);
    let anim = animations[idx];

    if (Array.isArray(animations)) {
      this.playAnim(
        scene,
        anim,
        0.25,
        false,
        true // this.randomRange(0, this.animations.idles.length, true)
      );
      if (animations[idx].sfx !== undefined) {
        this.playAnimSFX(scene, animations[idx].sfx);
      }
    } else {
      this.playAnim(
        scene,
        anim,
        0.25,
        false,
        true // this.randomRange(0, this.animations.idles.length, true)
      );
    }

    /*     if (debugTrace !== undefined) {
          console.log(this.name + ' --> ' + debugTrace + ' --> playing ' + anim);
        } */
  }

  playAnimSFX(scene, sfx) {
    let idx = Phaser.Math.Between(0, sfx.length - 1);
    scene.sound.play(sfx[idx], { volume: 0.5 });
  }

  playHappy(scene) {
    this.resetIdle();
    this.setTimescale(0.9, 1.1);
    this.playAnimVariant(scene, this.animations.happy, 'HAPPY');
  }

  playCelebrate(scene) {
    this.resetIdle();
    this.playAnimVariant(scene, this.animations.celebrate, 'CELEBRATE');
  }

  playSad(scene) {
    this.resetIdle();
    this.playAnimVariant(scene, this.animations.sad, 'SAD');
  }

  togglePause(paused) {
    this.idleActive = paused ? false : this.canIdle;
    this.spineChar.state.timeScale = paused ? 0 : 1;
  }

  handleCharacterClicked() {
    if (this.charActive) { this.emitter.emit('characterClicked', this.characterID); }
  }

  resetIdle() {
    this.idleCounter = 0;
    this.idleTime = Phaser.Math.Between(this.minIdleTime, this.maxIdleTime);
  }

  toggleActive(toggleOn) {
    this.charActive = !toggleOn;
    if (this.charActive) {
      this.spineChar.state.timescale = this.prevTimescale !== undefined ? this.prevTimescale : 1;
    } else {
      this.prevTimescale = this.spineChar.state.timescale;
      this.spineChar.state.timescale = 0;
    }
  }

  destroy() {
    this.transform.removeAll();
    this.transform = null;
    this.spineChar.destroy();
    this.spineChar = null;
    this.emitter = null;
    this.animations = null;
    super.destroy();
  }
}
